export function addBarcodes(code, scanCodes) {
  let uniqueCodes = new Set(scanCodes);
  let filteredCodes = Array.from(uniqueCodes.add(code));
  return filteredCodes;
}
